import React, { Component } from 'react';
import { Formik } from 'formik';
import PersonalInformation from '../profile/personal-information';
import UpdateImageModal from './update-image-modal';
import ChangePassword from './change-password';
import ChangePasswordQuestion from './change-password-question';
import { Log } from 'ng2-logger';
import 'react-image-crop/dist/ReactCrop.css';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IAction, IAppState } from '../../models/action/core';
import { IProfileProps } from '../../models/pages/profile';
import * as Actions from '../../store/actions/profile';
import Loading from '../../components/loading/loading';
import { getValidation } from '../../models/validations/profile-validation';
import Translator from '../../core/i18n';
import Preferences from '../profile/preferences';
import { IPreference } from '../../models/action/profile';
import moment from 'moment';
import ContentLoader from 'react-content-loader';
import { Common } from '../../core/common';
import Notifications from './notifications';
import { GetSendTwoFactorVerificationMail } from '../../store/actions/background';
import { checkVerificationCode, SetTwoFactorMethodError } from '../../store/actions/login';

const T = Translator.create();
const _logger = Log.create('profile');
const _common = new Common();

export class CProfileMain extends Component<IProfileProps, any> {
    formik: any;
    constructor(props: any) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.formik = null;
    }

    public dateConvert (date: string)
    {
        const parsedDate = moment(date, "DD.MM.YYYY");
        const formattedDate = parsedDate.format("YYYY-MM-DDTHH:mm:ss");
        return formattedDate;
    }

    public onSubmit(values: any) {
        values.dateFormat = this.findDateFormat(false);
        this.props.dispatch(Actions.updateProfileAction(values, () => { }, 'profileMainLoading', 'get'));
    }

    public componentDidUpdate(prevProps: any) {
        if (this.props.photoKey !== null && this.props.photoKey !== prevProps.photoKey) {
            this.props.dispatch(Actions.getProfileAction('profileMainLoading', 'get'));
        }

        if (prevProps.twoFactorVerificationError !== this.props.twoFactorVerificationError) {
            this.formik.setFieldValue(
                "twoFactorVerificationError",
                this.props.twoFactorVerificationError
            );
        }
    }

    public componentDidMount() {
        this.props.dispatch(Actions.getProfileAction('profileMainLoading', 'get'));
        this.props.dispatch(Actions.getTimezones('profileMainLoading', 'get'));
    }

    public handleChangeSwitch = (checked: any, event: any, id: any) => {
        const preferenceData: any = { preferences: [{ name: id, value: checked }] };
        this.props.dispatch(Actions.addOrUpdatePreferencesAction(preferenceData));
    }

    public handlesSendVerificationCode = (email: string, isEmailAdding: boolean) => {
        this.props.dispatch(GetSendTwoFactorVerificationMail(email, isEmailAdding, "GetSendTwoFactorVerificationMail"))
    }

    handleCheckVerificationCode = (username: string, verificationCode: string, callback: any) => {
        this.props.dispatch(checkVerificationCode(false, username, verificationCode, "checkVerificationCode", "get", callback));
    }

    public handleChange = (name: any, value: any) => {
        const preferenceData: any = { preferences: [{ name, value }] };
        this.props.dispatch(Actions.addOrUpdatePreferencesAction(preferenceData));
    }

    public handleResetError = () => {
        this.props.dispatch(SetTwoFactorMethodError(''))
    }

    public findDateFormat = (isDateTimeFormik: boolean) => {
        let dateFormat = 'DD.MM.YYYY';

        if (this.props.userPreferences && this.props.userPreferences.length > 0) {
            const userPrefrences = (this.props.userPreferences.find(pref => pref.name === 'application.dateformat') as IPreference);
            if (userPrefrences) {
                dateFormat = (this.props.userPreferences.find(pref => pref.name === 'application.dateformat') as IPreference).value;
            }
        }

        if (isDateTimeFormik) {
            switch (dateFormat) {
                case 'DD.MM.YYYY':
                    return 'd.m.Y';
                case 'MM.DD.YYYY':
                    return 'm.d.Y';
                default:
                    return 'd.m.Y';
            }
        }
        return dateFormat;
    }

    public render() {
        const loadingSpaces = 50;
        const tempDate = new Date('1940-01-01').getFullYear();
        const tempBirthDate = (this.props.profileData && this.props.profileData.birthDate) ? this.props.profileData.birthDate : '0001';
        const userDateFormat: string = _common.findDateFormat(this.props.userPreferences!);

        const initialFormValues = {
            ...this.props.profileData!,
            profileImagePath: this.props.profileImagePath!,
            photoKey: this.props.photoKey!,
            userPreferences: this.props.userPreferences!,
            handleChange: this.handleChange,
            handleChangeSwitch: this.handleChangeSwitch,
            birthDateFormatted: (this.props.profileData && parseInt(tempBirthDate.toString().substring(0, 4), 10) > tempDate) ? (moment(this.props.profileData.birthDate.toString()).format(userDateFormat).toString()) : '',
            dateFormat: this.findDateFormat(false),
            userType: this.props.userType!,
            isThereTwoFactorAuth: this.props.isThereTwoFactorAuth,
            isTwoFactorAuthOpen: this.props.profileData?.isTwoFactorAuthOpen,
            twoFactorAuthMailAddress: this.props.profileData?.twoFactorAuthMailAddress,
            twoFactorAuthMailAddress_checked: this.props.profileData?.twoFactorAuthMailAddress ?? '',
            sendVerificationCode: this.handlesSendVerificationCode,
            checkVerificationCode: this.handleCheckVerificationCode,
            twoFactorCode: '',
            twoFactorVerificationError: this.props.twoFactorVerificationError,
            handleResetError: this.handleResetError
        };
        return (


            <div className="profiles">
                <div className="container">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{T.t('r_personal_info')}</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">{T.t('r_preferences_and_alerts')}</a>
                        </li>
                        {/*
                    <li className="nav-item">
                        <a className="nav-link" id="noticication-tab" data-toggle="tab" href="#notification" role="tab" aria-controls="notification" aria-selected="false">{T.t('r_notification_settings')}</a>
                    </li> */}
                    </ul>
                    <Loading spinnerId={'profileMainLoading'}>
                        <div >
                            <ContentLoader
                                speed={2}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                viewBox="0 0 400 500"
                                style={{ width: '100%' }}
                            >
                                <rect x="10" y="8" rx="0" ry="0" width="125" height="25" />
                                <rect x="282" y="8" rx="10" ry="10" width="108" height="72" />
                                <rect x="145" y="8" rx="0" ry="0" width="125" height="25" />
                                <rect x="10" y="40" rx="0" ry="0" width="260" height="35" />
                                <rect x="10" y={40 + loadingSpaces} rx="0" ry="0" width="380" height="35" />
                                <rect x="10" y={40 + loadingSpaces * 2} rx="0" ry="0" width="380" height="35" />
                                <rect x="10" y={40 + loadingSpaces * 3} rx="0" ry="0" width="380" height="35" />
                                <rect x="10" y={40 + loadingSpaces * 4} rx="0" ry="0" width="380" height="35" />
                                <rect x="10" y={40 + loadingSpaces * 5} rx="0" ry="0" width="380" height="35" />
                                <rect x="10" y={40 + loadingSpaces * 6} rx="0" ry="0" width="380" height="35" />
                                <rect x="10" y={40 + loadingSpaces * 7} rx="0" ry="0" width="380" height="35" />
                                <rect x="10" y={40 + loadingSpaces * 8} rx="0" ry="0" width="380" height="35" />


                            </ContentLoader>
                        </div>
                    </Loading>
                    {this.props.profileData! && this.props.photoKey! && initialFormValues.userId ? (
                        <Formik
                            ref={(formik: any) => (this.formik = formik)}
                            initialValues={initialFormValues}
                            validationSchema={getValidation}
                            onSubmit={this.onSubmit}
                            // tslint:disable-next-line
                            render={props => (

                                <form onSubmit={props.handleSubmit}>
                                    <div className="tab-content" id="profileMainLoading_Content">
                                        <div className="tab-pane fade show active mb-5" id="home" role="tabpanel" aria-labelledby="home-tab">
                                            <PersonalInformation timezoneData={this.props.timezoneData} formik={this.formik} />
                                        </div>
                                        <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                            <Preferences />
                                        </div>
                                        <div className="tab-pane fade" id="notification" role="tabpanel" aria-labelledby="notification-tab">
                                            <Notifications />
                                        </div>
                                    </div>
                                    <UpdateImageModal />
                                </form>

                            )}
                        />
                    ) : (
                        ''
                    )}
                    <ChangePassword />
                    <ChangePasswordQuestion />
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IProfileProps): IProfileProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IProfileProps = Object.assign({}, ownProps, {
        activityCard: state.coursePage.activityCard,
        profileData: state.profile.profileData,
        timezoneData: state.profile.timezoneData,
        profileImagePath: state.login.identitiy.profileImagePath,
        userPreferences: state.profile.userPreferences.preferences,
        userType: state.login.identitiy.userType,
        photoKey: state.profile.photoKey,
        isThereTwoFactorAuth: state.login.login.isThereTwoFactorAuth,
        twoFactorVerificationError: state.login.twoFactorVerificationError
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.profile.profileData === prev.profile.profileData &&
        next.login.twoFactorVerificationError === prev.login.twoFactorVerificationError &&
        next.login.identitiy.profileImagePath === prev.login.identitiy.profileImagePath &&
        next.profile.userPreferences.preferences === prev.profile.userPreferences.preferences &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.profile.photoKey === prev.profile.photoKey &&
        next.login.login.isThereTwoFactorAuth === prev.login.login.isThereTwoFactorAuth
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const ProfileMain = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CProfileMain);

export default ProfileMain;
